import HeroSection from './components/HeroSection';
import ProfileSection from './components/ProfileSection';
import TopicsSection from './components/TopicsSection';
import ReviewSection from './components/ReviewSection';
import LinksSection from './components/LinksSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main className="w-full min-h-screen bg-white">
      <HeroSection />
      <ProfileSection />
      <TopicsSection />
      <ReviewSection />
      <LinksSection />
      <CTASection />
    </main>
  );
}
